import SuppliersReport from './SuppliersReportPage';

export default SuppliersReport;
